import filtericon from "./filter.svg";

export default function FilterIcon()
{
  return (
    <img src={filtericon}/>
  );
}